import React, { useEffect, useContext, useState } from 'react';
import { AddressList, MyAccountComp, MobileHeader1, CHeckoutAddress, AddressForm, ReactToast,Loder } from '../components/common';
import { Container, Row, Col } from 'react-bootstrap';
import { HiOutlinePlusSm } from "react-icons/hi";
import Sheet from 'react-modal-sheet';
import { useMediaQuery } from 'react-responsive';
import AddressAction from '../redux/actions/AddressAction';
import MasterAction from '../redux/actions/MasterAction';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
const AddressListComp = () => {
    const { getAddressList } = AddressAction();

    const dispatch = useDispatch()

    const { getProfileData } = MasterAction();

    const openform = useSelector(state => state.addressdata.openform);
    const addressData = useSelector(state => state.addressdata.addressData);
    const addressList = useSelector(state => state.addressdata.addressList);
    const addressOpen = useSelector(state => state.addressdata.addressOpen);

    const isDesktoporMobile = useMediaQuery({ query: `(max-width: 991px)` });

    useEffect(() => {
        {
            dispatch({ type: 'setAddressopen', payload: 1 })
            dispatch(getAddressList());
            dispatch(getProfileData())
        }
    }, [])
    const handlenewform = () => {
        dispatch({ type: 'setAddres', payload: '' })
        dispatch({ type: 'setaddressData', payload: [] })
        dispatch({ type: 'setopenform', payload: !openform })
        dispatch({
            type: 'setFormValues', payload: {
                name: "",
                phone: "",
                // mailid:"",
                address1: "",
                city:"",
                address2: "",
                pincode: "",
                country: "",
                state: "",
                addressId: "0",
                default: 1,
                addresstype: "Delivery"
            }
        })
    }

    return (
        <div>
            <Container>
            <Helmet>
        <title>{localStorage.getItem("title")} - Address</title>
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
        {/* <GoogleAnalytics trackingId={"G-ZDTRF1HJ43"}/> */}
      </Helmet>
                <Row className='custom-margin-top'>

                    {
                        !isDesktoporMobile &&
                        <Col lg={4} sm={12} xs={12}>
                            <MyAccountComp />
                        </Col>
                    }


                    <Col lg={6} md={12}>
                        <div className='accordion-deliver-viewmore mt-2 mb-2  contactAddressButton' onClick={() => handlenewform()}>
                            <HiOutlinePlusSm color="#ff7e00" style={{ marginTop: "-3px" }} /> Add new Address
                        </div>

                        {
                            (openform && addressData.length <= 0) &&
                            <div className='full-address-div'>
                                <AddressForm addressData={[]} showbtn={true} />

                            </div>
                        }
                        <div className='question'>
                            <div className='custom-checkout-accordionbody'>
                                {

                                    addressList != undefined && addressList.length > 0 &&
                                    <AddressList addressList={addressList} type={"fgfgf"} showbtn={true} />

                                }
                            </div>
                        </div>


                    </Col>

                    {
                        isDesktoporMobile &&

                        <Sheet isOpen={true} disableDrag={"yes"}
                        >
                            <Sheet.Container className='custom-checkout-address-modalsheet' >
                                <Sheet.Content >
                                    <MobileHeader1 />
                                    {/* {
                                        loaderstatus &&
                                        <div className='main-backdrop main-backdrop-extra'></div>
                                    } */}
                                    {
                                        addressOpen == 1 &&
                                        <>
                                            <div className='question'>
                                                <div className='custom-checkout-accordionbody'>
                                                    <CHeckoutAddress />
                                                </div>
                                            </div>
                                        </>

                                    }
                                    {
                                        addressOpen == 2 &&
                                        <>
                                            <div className='question' style={{ border: "none" }}>
                                                <AddressForm addressData={[]} />
                                            </div>
                                            <ReactToast />
                                        </>
                                    }
                                    {
                                        addressOpen == 3 &&
                                        <>
                                            <div className='question' style={{ border: "none" }}>
                                                <AddressForm addressData={addressData} />
                                            </div>
                                            <ReactToast />
                                        </>
                                    }

                                </Sheet.Content>
                                <Loder />
                            </Sheet.Container>
                            <Sheet.Backdrop />
                        </Sheet>
                    }

                </Row>
            </Container>

        </div>
    );
};

export default AddressListComp;